const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

const LIGHT_THEME = {
  template: 'plotly_white',
  paper_bgcolor: '#ffffff',
  plot_bgcolor: '#ffffff',
  font: { family: 'Inter, -apple-system, sans-serif', size: isMobile ? 10 : 12, color: '#333' },
  xaxis: { gridcolor: '#eee', zerolinecolor: '#ddd', tickfont: { size: isMobile ? 8 : 11 } },
  yaxis: { gridcolor: '#eee', zerolinecolor: '#ddd', tickfont: { size: isMobile ? 8 : 11 } },
};

const DARK_THEME = {
  paper_bgcolor: '#161b22',
  plot_bgcolor: '#161b22',
  font: { family: 'Inter, -apple-system, sans-serif', size: isMobile ? 10 : 12, color: '#e6e1d8' },
  xaxis: { gridcolor: '#1e2a3a', zerolinecolor: '#1e2a3a', tickfont: { size: isMobile ? 8 : 11 } },
  yaxis: { gridcolor: '#1e2a3a', zerolinecolor: '#1e2a3a', tickfont: { size: isMobile ? 8 : 11 } },
};

// Themes carry colours and sizes only — never a tickformat. A chart's number format is part of its
// meaning, so it must not depend on the theme: percent-valued charts pass their own
// `yaxis: { tickformat: '.1%' }`. (mergeLayout is a shallow spread, so a caller's `yaxis` replaces
// the theme's `yaxis` wholesale, grid colours included.)

const BASE_LAYOUT = {
  hovermode: 'x unified',
  legend: isMobile
    ? { orientation: 'h', yanchor: 'top', y: -0.15, xanchor: 'center', x: 0.5, font: { size: 9 } }
    : { orientation: 'h', yanchor: 'bottom', y: 1.02, xanchor: 'right', x: 1 },
  margin: isMobile
    ? { l: 40, r: 8, t: 10, b: 30 }
    : { l: 55, r: 15, t: 35, b: 40 },
  autosize: true,
};

export const getThemeLayout = (theme) => {
  const palette = theme === 'dark' ? DARK_THEME : LIGHT_THEME;
  return { ...BASE_LAYOUT, ...palette };
};

export const HEATMAP_DIVERGING = [[0, '#2166AC'], [0.5, '#F7F7F7'], [1, '#B2182B']];
export const HEATMAP_RETURNS = [[0, '#DC3545'], [0.5, '#FFFFFF'], [1, '#28A745']];

export const PLOTLY_CONFIG = {
  displayModeBar: false,
  displaylogo: false,
  responsive: true,
};

export const mergeLayout = (overrides = {}, theme = 'light') => {
  return { ...getThemeLayout(theme), ...overrides };
};
